import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
//import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/map';
import { map ,delay,debounceTime } from 'rxjs/operators';

import { AppGlobals } from '../shared/app.global';
import  dataurl from '../../assets/config.json';
export interface Dropobj {

  label;
  value;


  }

  declare function Getapiurl():any;

@Injectable()
export class LibraryService {

    callurl: string = '';
    pdfurl:string='';
  
clcd:string;
aycd:string;
usid:string;

    constructor(private http: HttpClient,private _global: AppGlobals) {

       this.clcd=localStorage.getItem('clcd');
       this.aycd=localStorage.getItem('aycd');
       this.usid=localStorage.getItem('usid');
     
       this.callurl=_global.baseAPIUrl;
       this.pdfurl=_global.pdfurl;
     }

     getipurl(): any {
      debugger
     //let clcd=localStorage.getItem('clcd');
     const headers = new HttpHeaders();
     headers.append('Content-Type', 'application/json')
         
         headers .append('Access-Control-Allow-Methods', 'GET')
         headers.append('Access-Control-Allow-Origin', '*'); 
         headers.append('Access-Control-Allow-Headers', 'X-Requested-With,content-type');
     return this.http.get('http://mycampuz.co.in/ipwithport.php',{responseType:'text', headers:headers})
     .pipe(map((data: any) => {
             console.log('retres',JSON.stringify(data));
             this.callurl= data+'/mycampz/v3/';
         }));
   }

   getdatetoday()
   {
    let d: Date = new Date();
    var mnth;
    var day='';
    //let todayDate = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
    if(d.getMonth()>=10)
    {
      mnth=d.getMonth()+1;
    }
    else{
     // mnth='0'+d.getMonth()+1;
     mnth=d.getMonth()+1;
     mnth='0'+mnth;
    }
 
    if(d.getDate()>=10)
    {
      day=d.getDate().toString();
    }
    else{
      day='0'+d.getDate();
    }
    let todayDate =  d.getFullYear()+'-'+ mnth+'-' +day;
      
 return todayDate;
 
   }

   getsysdatetoday()
   {
    return this.http.get(this.callurl + 'getsysdate')
    .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
 
   }

   getmontfirstdate()
   {
    return this.http.get(this.callurl + 'getfirstdate')
    .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
 
   }

   getmontlastdate()
   {
    return this.http.get(this.callurl + 'getlastdate')
    .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
 
   }
    Getdashboarddata(oprtype): Observable<any> {
        //let clcd=localStorage.getItem('clcd');
        
        let postdat={clcd:this.clcd,aycd:this.aycd}
        //console.log('url',this.callurl + 'libdashboard/'+this.clcd+'/'+this.aycd+'/'+oprtype);
        return this.http.get(this.callurl + 'libdashboard/'+this.clcd+'/'+this.aycd+'/'+oprtype)
        .pipe(map((data: any) => {
                console.log('retres', data);
                return data.dashboard;
            }));
    }


    getBooks() {
        return this.http.get<any>('assets/books.json')
          .toPromise()
          .then(res => res.data)
          .then(data => { return data; });
        }

        getbookdetails(): Observable<any> {
          debugger
          // let clcd=localStorage.getItem('clcd');
          // let aycd=localStorage.getItem('aycd');
          let postdat={clcd:this.clcd,aycd:this.aycd}
          return this.http.post(this.callurl + 'getlibbooks', postdat)
          .pipe(map((data: any) => {
                  console.log('bookdetails', data);
                  return data.bookdetails;
                  
              }));
      }

      

      serchbooks(sertext: any,booktype:any,bkcat:any): Observable<any> {
        debugger
        let clcd=localStorage.getItem('clcd');
        let aycd=localStorage.getItem('aycd');
        let postdat={sertxt:sertext,clcd:clcd,aycd:aycd,booktype:booktype,bkcat:bkcat}
        return this.http.post(this.callurl+ 'serchbook', postdat)
            .pipe(map((data: any) => {
                console.log('retres', data);
                return data.bookdetails;
            }),delay(2000));
    }

    copiescount(sertext: any,booktype:any,bkcat:any): Observable<any> {
      debugger
      let clcd=localStorage.getItem('clcd');
      let aycd=localStorage.getItem('aycd');
      let postdat={sertxt:sertext,clcd:clcd,aycd:aycd,booktype:booktype,bkcat:'1'}
      return this.http.post(this.callurl+ 'serchbook', postdat)
          .pipe(map((data: any) => {
              console.log('retres', data);
              return data.bookdetails;
          }));
  }
   


    getmemberdetails(oprtype,sertxt,clid,crid): Observable<any> {
      // debugger
        let clcd=localStorage.getItem('clcd');
        let aycd=localStorage.getItem('aycd');
        //let cldb=localStorage.getItem('cldb');
        
       let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,sertxt:sertxt,clid:clid,crsid:crid,status:status};
       return this.http.post(this.callurl + 'libmembers', postdat)
      // return this.http.get(this.callurl + 'libmembers/0/0/'+cldb+'/'+clcd+'/'+aycd+'/0')
       .pipe(map((data: any) => {
               console.log('retres', data);
               return data.libmembers;
           }));
   }


   bulkissuebook(bookid: any): Observable<any> {
                        
    debugger
    bookid.usid=this.usid;
    // let clcd=localStorage.getItem('clcd');
    //         let aycd=localStorage.getItem('aycd');
    // var admdata={bookid:bookid,stuid:stuid,clcd:clcd,aycd:aycd}
    return this.http.post(this.callurl + 'bulkissuebook', bookid)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data
        }));
}

 getstafflist(): Observable<any> {
                        
    debugger
  
    return this.http.get(this.callurl + 'sel_sp_hrmemployee/'+this.clcd+'/'+this.aycd)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data.sp_hrmemployee;
        }));
}

checkholiday(hodt): Observable<any> {
                        
  debugger
  //let clcd=localStorage.getItem('clcd');
         //  let aycd=localStorage.getItem('aycd');
  // var admdata={bookid:bookid,stuid:stuid,clcd:clcd,aycd:aycd}
  return this.http.get(this.callurl + 'checkholiday/'+this.clcd+'/'+this.aycd+'/'+hodt)
      .pipe(map((data: any) => {
          console.log('retres', 'response');
          return data
      }));
}


extendduedate(): Observable<any> {
                        
  debugger
  //let clcd=localStorage.getItem('clcd');
         //  let aycd=localStorage.getItem('aycd');
  // var admdata={bookid:bookid,stuid:stuid,clcd:clcd,aycd:aycd}
  return this.http.get(this.callurl + 'extendduedate/'+this.clcd+'/'+this.aycd+'/'+this.usid)
      .pipe(map((data: any) => {
          console.log('retres', 'response');
          return data
      }));
}
   issuebook(bookid: any): Observable<any> {
                        
    debugger
    bookid.usid=this.usid;
    // let clcd=localStorage.getItem('clcd');
    //         let aycd=localStorage.getItem('aycd');
    // var admdata={bookid:bookid,stuid:stuid,clcd:clcd,aycd:aycd}
    return this.http.post(this.callurl + 'issuebook', bookid)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data
        }));
}
checklimit(bookid: any,stuid): Observable<any> {
                        
  debugger
  // let clcd=localStorage.getItem('clcd');
  //         let aycd=localStorage.getItem('aycd');
   var admdata={bookid:bookid,stuid:stuid,clcd:this.clcd,aycd:this.aycd};
  return this.http.post(this.callurl + 'checkissuelimit', admdata)
      .pipe(map((data: any) => {
          console.log('retres', 'response');
          return data
      }));
}
getissueddetails(stuid: any,oprtype:any): Observable<any> {
 
  let postdat={stuid:stuid,clcd:this.clcd,aycd:this.aycd,oprtype:oprtype}
  return this.http.post( this.callurl + 'getissueddetails', postdat)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.bookdetails;
      }));

}

getopacbooks(sertxt: any,oprtype:any): Observable<any> {
 
  let postdat={sertxt:sertxt,clcd:this.clcd,aycd:this.aycd,oprtype:oprtype}
  return this.http.post( this.callurl + 'getopacbooks', postdat)
      .pipe(debounceTime(2000),map((data: any) => {
          console.log('retres', data);
          return data.opacbooks;
      }));

}

getopacglobbooks(sertxt: any): Observable<any> {
 
 // let postdat={sertxt:sertxt,clcd:this.clcd,aycd:this.aycd,oprtype:oprtype}
  return this.http.get( this.callurl + 'bookserchglobal/'+sertxt)
      .pipe(debounceTime(2000),map((data: any) => {
          console.log('retres', data);
          return data;
      }));

}

getopacbookdash(): Observable<any> {
 
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post( this.callurl + 'getopacbookdash', postdat)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.dashcount;
      }));

}

getissuedbookdetails(stuid: any,oprtype:any): Observable<any> {
  debugger
 
  let postdat={bookid:stuid,clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,memtype:''}
  return this.http.post( this.callurl + 'getissuedbookdtls', postdat)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.bookdetails;
      }));
}

getissuedbookdetails1(stuid: any,oprtype:any,memtype:any): Observable<any> {
  debugger
 
  let postdat={bookid:stuid,clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,memtype:memtype}
  return this.http.post( this.callurl + 'getissuedbookdtls', postdat)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.bookdetails;
      }));
}

getissuedbookinfocnts(stuid: any): Observable<any> {
  debugger
 
  let postdat={bookid:stuid,clcd:this.clcd,aycd:this.aycd}
  return this.http.post( this.callurl + 'getissuedbookinfocnts', postdat)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.bookdetails;
      }));
}


getissuedbookinfocnts1(stuid: any,memtype:any): Observable<any> {
  debugger
 
  let postdat={bookid:stuid,clcd:this.clcd,aycd:this.aycd,memtype:memtype}
  return this.http.post( this.callurl + 'getissuedbookinfocnts', postdat)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.bookdetails;
      }));
}

getissuedbookcnts(bookid: any): Observable<any> {
  debugger
 
  let postdat={bookid:bookid,clcd:this.clcd,aycd:this.aycd}
  return this.http.post( this.callurl + 'getissuedbooktranscnts', postdat)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.bookdetails;
      }));
}



getlibissuehistory(oprtype:any,bkretstatus:any,issuedt1:any,issuedt2:any): Observable<any> {
 
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,issuedt1:issuedt1,issuedt2:issuedt2,bkretstatus:bkretstatus};
  return this.http.post( this.callurl + 'libissuehistory', postdat)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.issuedata;
      }));
}

   getclassdetails(): Observable<any> {
     // debugger
       let clcd=localStorage.getItem('clcd');
       let aycd=localStorage.getItem('aycd');

      return this.http.get(this.callurl + 'classlist/'+clcd+'/'+aycd)
      .pipe(map((data: any) => {
              console.log('classdata', data);
              return data.classdata;
          }));
  }

  getlibsettings(): Observable<any> {
    debugger
    // let clcd=localStorage.getItem('clcd');
    // let aycd=localStorage.getItem('aycd');libsubjectgroup
    let postdat={clcd:this.clcd,aycd:this.aycd}
    return this.http.post(this.callurl + 'getlibsettings', postdat)
    .pipe(map((data: any) => {
            console.log('retres', data);
            return data.libsettings;
            
        }));
  }

getlibsupplier(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getlibsupplier', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.libsupplier;
          
      }));
}

serlibsupplier(oprtype,sertxt): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,sertxt:sertxt};
  return this.http.post(this.callurl + 'serlibsupplier', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.libsupplier;
          
      }));
}

savelibsupplier(objmodel): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:objmodel.oprtype,supid:objmodel.supid,supnm:objmodel.supnm,street1:objmodel.street1,street2:objmodel.street2,
    phoneno:objmodel.phoneno,email:objmodel.email,city:objmodel.city,status:objmodel.status,suptype:objmodel.suptype};
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'savelibsupplier', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}
getlibaccesiontype(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getlibaccesiontype', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.libaccessiontypes;
          
      }));
}

savelibaccesiontype(catmodel): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:catmodel.oprtype,acsid:catmodel.acsid,acsnm:catmodel.acsnm};
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'save_libaccessiontype', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}
getlibsubjects(): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getlibsubjects', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          //var subdata=data.libsubjects;
         
          return data.libsubjects;
          
      }));
}

serlibsubjects(oprtype,sertxt): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,sertxt:sertxt};
  return this.http.post(this.callurl + 'serlibsubjects', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          //var subdata=data.libsubjects;
         
          return data.libsubjects;
          
      }));
}

savelibsubjects(objmodel): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:objmodel.oprtype,subid:objmodel.subid,subnm:objmodel.subnm,parentsubid:objmodel.parentsubid,
    deweyno:objmodel.deweyno,status:objmodel.status};
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'savelibsubjects', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

savesettings(objmodel): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:objmodel.oprtype,id:objmodel.id,bkcatid:objmodel.bkcatid,nod:objmodel.nod,
    fineperday:objmodel.fineperday,status:objmodel.status,memtype:objmodel.memtype,issuelimit:objmodel.issuelimit};
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'savelibsettings', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}
getlibsubjectgroup(): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getlibsubjecgroup', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.libsubjectgroup;
          
      }));
}

getlibcategory(): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getlibcategory', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.libbookcategory;
          
      }));
}

getidcardsetting(): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.get(this.callurl + 'idcardsettings/'+this.clcd)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.idcardsettings;
          
      }));
}

changeidcardsetting(obj): Observable<any> {
  
  
  
  return this.http.get(this.callurl + 'changeidcardsettings/'+this.clcd+'/'+obj.type+'/'+obj.status)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}
savelibcategory(catmodel): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:catmodel.oprtype,bkcatnm:catmodel.bkcatnm,bkcatid:catmodel.bkcatid,status:catmodel.status};
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'savelibcategory', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}
getlibpublisher(oprtype): Observable<any> {
  debugger
 
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype}
  return this.http.post(this.callurl + 'getlibpublisher', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.libpublisher;
          
      }));
}

serlibpublisher(oprtype,sertxt): Observable<any> {
  debugger
 
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,sertxt:sertxt};
  return this.http.post(this.callurl + 'serlibpublisher', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.libpublisher;
          
      }));
}


savelibpublisher(objmodel): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:objmodel.oprtype,pubid:objmodel.pubid,pubnm:objmodel.pubnm,state:objmodel.state,website:objmodel.website,
    phoneno:objmodel.phoneno,fax:objmodel.fax,email:objmodel.email,city:objmodel.city,addess:objmodel.addess,status:objmodel.status,pubtype:objmodel.pubtype};
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'savelibpublisher', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

getlibsource(): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getlibsource', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          // data.libsource.status == "true" ? data.libsource.status= true : data.libsource.status = false
          // console.log('retres1', data);
          return data.libsource;
          
      }));
}

getbkfields(): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.get(this.callurl + 'libbkmascolums')
  .pipe(map((data: any) => {
          console.log('retres', data);
          // data.libsource.status == "true" ? data.libsource.status= true : data.libsource.status = false
          // console.log('retres1', data);
          return data.listcolumns;
          
      }));
}

savelibsource(objmodel): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:objmodel.oprtype,srcnm:objmodel.srcnm,srcid:objmodel.srcid,status:objmodel.status};
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'savelibsource', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

updbookmaster(objmodel): Observable<any> {
  debugger
  
  // let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:objmodel.oprtype,srcnm:objmodel.srcnm,srcid:objmodel.srcid,status:objmodel.status};
  // console.log('saveobj',postdat);
  objmodel.clcd=this.clcd;
  objmodel.aycd=this.aycd;
  return this.http.post(this.callurl + 'updbookmaster', objmodel)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}
getlibdepartment(): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getlibdepartment', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          
          return data.libdepartment;
          
      }));
}
savelibdepart(objmodel): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:objmodel.oprtype,bkdepnm:objmodel.bkdepnm,bkdepid:objmodel.bkdepid,status:objmodel.status};
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'savelibdepartment', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}


booksdashcounts(): Observable<any> {
  debugger
  
  //let postdat={clcd:this.clcd,aycd:this.aycd}6273
  console.log('url',this.callurl + 'libdashboard/'+this.clcd+'/'+this.aycd+'/booksdashcount');
  return this.http.get(this.callurl + 'libdashboard/'+this.clcd+'/'+this.aycd+'/booksdashcount')
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.dashboard;
          
      }));
}

savelibbookmaster(boomodel,oprtype): Observable<any> {
  debugger
 var bk=boomodel;
  let postdat={clcd:this.clcd,aycd:this.aycd,accno:bk.accno,accnstatus:bk.accnstatus,author:bk.author,authorccode:bk.authorccode,billdt:bk.billdt,
    billno:bk.billno, bindtype:bk.bindtype,bkcatid:bk.bkcatid,bkid:bk.bkid,bksecid:bk.bksecid,bkstatus:bk.bkstatus,callno:bk.callno,classno:bk.classno,
    crby:this.usid,mdby:this.usid,currencyid:bk.currencyid,deptid:bk.deptid,disc:bk.disc,edition:bk.edition,isbn:bk.isbn,languageid:bk.languageid,location:bk.location,
    mrp:bk.mrp,netamt:bk.netamt,pages:bk.pages,prate:bk.prate,publisher:bk.publisher,pubplace:bk.pubplace,pubyr:bk.pubyr,series:bk.series,source:bk.source,
    strmedia:bk.strmedia,subjectid:bk.subjectid,supid:bk.supid,title:bk.title,titlesub:bk.titlesub,volume:bk.volume,oprtype:oprtype,verifiedstatus:bk.verifiedstatus,keywords:bk.keywords,remarks:bk.remarks

  
  }
console.log('postdata',postdat);
  return this.http.post(this.callurl + 'savelibbookmaster', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

bulksavelibbookmaster(boomodel,copies): Observable<any> {
  debugger
 var bk=boomodel;
  let postdat={clcd:this.clcd,aycd:this.aycd,accno:bk.accno,accnstatus:bk.accnstatus,author:bk.author,authorccode:bk.authorccode,billdt:bk.billdt,
    billno:bk.billno, bindtype:bk.bindtype,bkcatid:bk.bkcatid,bkid:bk.bkid,bksecid:bk.bksecid,bkstatus:bk.bkstatus,callno:bk.callno,classno:bk.classno,
    crby:this.usid,mdby:this.usid,currencyid:bk.currencyid,deptid:bk.deptid,disc:bk.disc,edition:bk.edition,isbn:bk.isbn,languageid:bk.languageid,location:bk.location,
    mrp:bk.mrp,netamt:bk.netamt,pages:bk.pages,prate:bk.prate,publisher:bk.publisher,pubplace:bk.pubplace,pubyr:bk.pubyr,series:bk.series,source:bk.source,
    strmedia:bk.strmedia,subjectid:bk.subjectid,supid:bk.supid,title:bk.title,titlesub:bk.titlesub,volume:bk.volume,oprtype:'insert',verifiedstatus:bk.verifiedstatus,copies:copies,keywords:bk.keywords,remarks:bk.remarks

  
  }
console.log('postdata',postdat);
  return this.http.post(this.callurl + 'bulksavelibbookmaster', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}
getgenmasters(mastype): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  let postdat={clcd:this.clcd,aycd:this.aycd,mastypenm:mastype};
  return this.http.post(this.callurl + 'selibmasgeneral', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.detarr;
          
      }));
}

genaratereceivables(pdid,sbid): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  let postdat={clcd:this.clcd,aycd:this.aycd,pdid:pdid,sbid:sbid};
  return this.http.post(this.callurl + 'genaratereceivables', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

checklibtsubreceivable(pdid,sbid): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  let postdat={clcd:this.clcd,aycd:this.aycd,pdid:pdid,sbid:sbid};
  return this.http.post(this.callurl + 'checklibtsubreceivable', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.rcnt;
          
      }));
}

SavegenmasDetails(objmodel): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:objmodel.oprtype,id:objmodel.id,name:objmodel.name,mastypenm:objmodel.mastypenm
    };
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'savelibmasgeneral', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

getlibmasgeneral(): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getlibmasgeneral', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          
          return data.libmasgeneral;
          
      }));
}

getlibvisitorrecord(frdt,todt,chtype): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,frdt:frdt,todt:todt,chtype:chtype};
  console.log('postdat',postdat);
  return this.http.post(this.callurl + 'getlibvisitorrecord', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          
          return data.libvisitorrecord;
          
      }));
}

getvisitoroverview(frdt,todt,chtype): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,frdt:frdt,todt:todt,chtype:chtype};
  console.log('postdat',postdat);
  return this.http.post(this.callurl + 'getvisitoroverview', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          
          return data.visitoroverview;
          
      }));
}

getlabvisitorrecord(frdt,todt): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,frdt:frdt,todt:todt};
  console.log('postdat',postdat);
  return this.http.post(this.callurl + 'getlabvisitorrecord', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          
          return data.libvisitorrecord;
          
      }));
}

getlibmfrequency(): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getlibmfrequency', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          
          return data.libmfrequency;
          
      }));
}

getlibmpdcat(): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getlibmpdcat', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          
          return data.libmpdcat;
          
      }));
}

getlibmpdtype(): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getlibmpdtype', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          
          return data.libmpdtype;
          
      }));
}


getlibmperiodical(oprtype): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype}
  return this.http.post(this.callurl + 'getlibmperiodical', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          
          return data.libmperiodical;
          
      }));
}




Savelibmperiodical(objmodel): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:objmodel.oprtype,pdid:objmodel.pdid,pdcd:objmodel.pdcd,pdtitle:objmodel.pdtitle,
    fqid:objmodel.fqid,pdtypeid:objmodel.pdtypeid,pdcatid:objmodel.pdcatid,lgid:objmodel.lgid,classno:objmodel.classno,callno:objmodel.callno,subid:objmodel.subid,issn:objmodel.issn,editor:objmodel.editor,pubid:objmodel.pubid,
    pubplace:objmodel.pubplace,website:objmodel.website,email:objmodel.email,phone:objmodel.phone,pdvrtype:objmodel.pdvrtype
    };
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'savelibmperiodical', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

saverefbook(objmodel): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:objmodel.oprtype,refdt:objmodel.refdt,rid:objmodel.rid,accno:objmodel.accno,crby:this.usid,mdby:this.usid
    };
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'savelibtbkref', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}



getlibtsubscriptionh(oprtype): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype}
  return this.http.post(this.callurl + 'getlibtsubscriptionh', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          
          return data.libtsubscriptionh;
          
      }));
}

dellibtsubscriptionh(sbid): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,sbid:sbid}
  return this.http.post(this.callurl + 'deletelibtsubscriptionh', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          
          return data;
          
      }));
}

dellibtsubreceivable(sbid): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,srid:sbid}
  return this.http.post(this.callurl + 'dellibtsubreceivable', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          
          return data;
          
      }));
}

getlibtsubreceivable(oprtype,dt1,dt2,status): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,frdt:dt1,todt:dt2,status:status}
  return this.http.post(this.callurl + 'getlibtsubreceivable', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          
          return data.libtsubreceivable;
          
      }));
}
savelibtsubscriptionh(objmodel): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:objmodel.oprtype,sbid:objmodel.sbid,pdid:objmodel.pdid,sbdt:objmodel.sbdt,exdt:objmodel.exdt,
    ptdt:objmodel.ptdt,pono:objmodel.pono,podt:objmodel.podt,supid:objmodel.supid,copies:objmodel.copies,billno:objmodel.billno,billdt:objmodel.billdt,
    currencyid:objmodel.currencyid,mrp:objmodel.mrp,prate:objmodel.prate,expdt:objmodel.expdt,
    disc:objmodel.disc,netamt:objmodel.netamt,deptid:objmodel.deptid,srcid:objmodel.srcid,oprtag:objmodel.oprtag,mop:objmodel.mop,refno:objmodel.refno,sbno:objmodel.sbno
    };
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'savelibtsubscriptionh', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

savelibtsubreceivable(objmodel): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:objmodel.oprtype,srid:objmodel.srid,sbid:objmodel.sbid,pdid:objmodel.pdid,
    cpno:objmodel.cpno,volno:objmodel.volno,issno:objmodel.issno,issdt:objmodel.issdt,exrecdt:objmodel.exrecdt,recdt:objmodel.recdt,cpqty:objmodel.cpqty,accno:objmodel.accno,
    currencyid:objmodel.currencyid,mrp:objmodel.mrp,prate:objmodel.prate,
    disc:objmodel.disc,netamt:objmodel.netamt,status:objmodel.status
    };
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'savelibtsubreceivable', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}
checkmemberrecord(oprtype,memno): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,memno:memno}
  return this.http.post(this.callurl + 'checkmember', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          
          return data.memrecord;
          
      }));
}

checklabmemberrecord(oprtype,memno): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,memno:memno}
  return this.http.post(this.callurl + 'checklabmember', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          
          return data.memrecord;
          
      }));
}
savelibvisitorrecord(objmodel): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:objmodel.oprtype,id:objmodel.id,memid:objmodel.memid,memtype:objmodel.memtype};
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'savelibvisitorrecord', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

savelabvisitorrecord(objmodel): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:objmodel.oprtype,id:objmodel.id,memid:objmodel.memid,memtype:objmodel.memtype};
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'savelabvisitorrecord', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}
visitorcheckin(memno): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,memno:memno};
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'visitorcheckin', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

labvisitorcheckin(memno): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,memno:memno};
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'labvisitorcheckin', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

getlibresources(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  let postdat={clcd:this.clcd,aycd:this.aycd};
  return this.http.post(this.callurl + 'getlibresources', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.libresources;
          
      }));
}

savelibresources(objmodel): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:objmodel.oprtype,resid:objmodel.resid,resdesc:objmodel.resdesc,reslink:objmodel.reslink,recordstatus:objmodel.recordstatus,restype:objmodel.restype
    };
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'savelibresources', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

getslibmbksection(): Observable<any> {
 
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post( this.callurl + 'getslibmbksection', postdat)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.libmbksection;
      }));
}

savelibmbksection(objmodel): Observable<any> {
  debugger
  
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:objmodel.oprtype,bksecnm:objmodel.bksecnm,bksecid:objmodel.bksecid,status:objmodel.status,crby:this.usid,mdby:this.usid};
  console.log('saveobj',postdat);
  return this.http.post(this.callurl + 'savelibmbksection', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

getperiodicaldashcounts(): Observable<any> {
 
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post( this.callurl + 'getperiodicaldashcounts', postdat)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.periodicaldashboard;
      }));
}

getlibvisitordashcounts(oprtype): Observable<any> {
 
  let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype};
  return this.http.post( this.callurl + 'getlibvisitordashcounts', postdat)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.libvisitordashboard;
      }));
}

getlabvisitordashcounts(): Observable<any> {
 
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post( this.callurl + 'getlabvisitordashcounts', postdat)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.libvisitordashboard;
      }));
}


getlibclasses(): Observable<any> {

  var enqpost={clcd:this.clcd,aycd:this.aycd};
      
  //this.callurl='https://mycampuz.co.in/schoolpayment/admclasslist.php'
  

  // this.callurl=this.baseUrl+'Payenqrequest'
   return this.http.get(  this.callurl +"getlibclass/"+this.clcd+"/"+this.aycd )
       .pipe(map((data: any) => 
       {
           console.log('clases',data);
           return  data.libclass ; 
       }));
} 
getinstite(): Observable<any> {

  var enqpost={clcd:this.clcd,aycd:this.aycd};
      
  //this.callurl='https://mycampuz.co.in/schoolpayment/admclasslist.php'
  

  // this.callurl=this.baseUrl+'Payenqrequest'
   return this.http.get(  this.callurl +"getmasinstitute/"+this.clcd+"/"+this.aycd )
       .pipe(map((data: any) => 
       {
           console.log('clases',data);
           return  data.masinstitute ; 
       }));
} 

getcourse(): Observable<any> {

  var enqpost={clcd:this.clcd,aycd:this.aycd};
      
  //this.callurl='https://mycampuz.co.in/schoolpayment/admclasslist.php'
  

  // this.callurl=this.baseUrl+'Payenqrequest'
   return this.http.get(  this.callurl +"getmascourse/"+this.clcd+"/"+this.aycd )
       .pipe(map((data: any) => 
       {
           console.log('clases',data);
           return  data.mascourse ; 
       }));
} 

masbloodgroups(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  return this.http.get( this.callurl  + 'masbloodgroup/'+this.clcd+'/'+this.aycd)
  .pipe(map((data: any) => {
          console.log('retres-data', data);
          return data.masbloodgroup;
          
      }));
}

savememberstudent(rd: any): Observable<any> {

  var enqpost={clcd:this.clcd,aycd:this.aycd,oprtype:rd.oprtype,memid:rd.memid,memname:rd.memname,clientid:rd.definst,clid:rd.defclass,gender:rd.defgender,status:rd.status,
      mobileno:rd.mobileno,email:rd.emailid,address:rd.address,dob:rd.dob,blgrp:rd.defblgrp,crsid:rd.defcorse,city:rd.city,pin:rd.pincode,fatname:rd.fatname,fatmobile:rd.fatmobile,memcd:rd.memcd,expdt:rd.expdt,sbscrdt:rd.sbscrdt,secid:rd.secid,admno:rd.admno,catid:rd.catid,ayid:rd.ayid,qinnm:rd.qinnm,qpct:rd.qpct};
      
  //this.callurl= this.callurl + 'saveregdata'
  

  // this.callurl=this.baseUrl+'Payenqrequest'
   return this.http.post( this.callurl + 'saveregdata', enqpost )
       .pipe(map((data: any) => 
       {
           console.log('retres',data);
           return  data ; 
       }));
}  

savememberstaff(rd: any): Observable<any> {

  var enqpost={clcd:this.clcd,aycd:this.aycd,oprtype:rd.oprtype,memid:rd.memid,memname:rd.memname,clientid:rd.definst,gender:rd.defgender,crsid:rd.crsid,status:rd.status,
      mobileno:rd.mobileno,email:rd.emailid,address:rd.address,dob:rd.dob,blgrp:rd.defblgrp,city:rd.city,pin:rd.pincode,memtype:rd.defmemtype,clid:rd.clid,memcd:rd.memcd,expdt:rd.expdt,sbscrdt:rd.sbscrdt,doj:rd.doj};
      
      console.log('enqpost',enqpost);
 // this.callurl= this.callurl + 'savememstaff'
  

  // this.callurl=this.baseUrl+'Payenqrequest'
   return this.http.post( this.callurl + 'savememstaff', enqpost )
       .pipe(map((data: any) => 
       {
           console.log('retres',data);
           return  data ; 
       }));
} 

savelibtsah(rd: any): Observable<any> {

  var enqpost={clcd:this.clcd,aycd:this.aycd,oprtype:rd.oprtype,said:rd.said,sanm:rd.sanm,sdt:rd.sdt,
    edt:rd.edt,rmk:rd.rmk,crby:this.usid,mdby:this.usid};
      
      console.log('enqpost',enqpost);
      var callurl= this.callurl + 'savelibtsah'
  

  // this.callurl=this.baseUrl+'Payenqrequest'
   return this.http.post( callurl, enqpost )
       .pipe(map((data: any) => 
       {
           console.log('retres',data);
           return  data ; 
       }));
} 


getlibtsah(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  return this.http.get( this.callurl  + 'getlibtsah/'+this.clcd+'/'+this.aycd)
  .pipe(map((data: any) => {
          console.log('retres-getlibtsah', data);
          return data.libtsah;
          
      }));
}

getlibtsad(said,oprtype): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  return this.http.get( this.callurl  + 'getlibtsad/'+this.clcd+'/'+this.aycd+'/'+said+'/'+oprtype)
  .pipe(map((data: any) => {
          console.log('retres-getlibtsah', data);
          return data.libtsad;
          
      }));
}

serchlibtsad(said,srchtxt): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  var pstdata={said:said,srchtxt:srchtxt,clcd:this.clcd,aycd:this.aycd};
  return this.http.post( this.callurl  + 'serchlibtsad',pstdata)
  .pipe(map((data: any) => {
          console.log('retres-getlibtsah', data);
          return data.libtsad;
          
      }));
}

dellibtsad(said): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  return this.http.get( this.callurl  + 'dellibtsad/'+this.clcd+'/'+this.aycd+'/'+said)
  .pipe(map((data: any) => {
          console.log('retres-getlibtsah', data);
          return data;
          
      }));
}

delduplibtsad(said): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  return this.http.get( this.callurl  + 'delduplibtsad/'+this.clcd+'/'+this.aycd+'/'+said)
  .pipe(map((data: any) => {
          console.log('retres-getlibtsah', data);
          return data;
          
      }));
}

savelibtsad(rd: any): Observable<any> {

  var enqpost={clcd:this.clcd,aycd:this.aycd,oprtype:'insert',said:rd.said,accno:rd.accno,rmk:rd.rmk,crby:this.usid,mdby:this.usid,rid:0,location:rd.location};
      
      console.log('enqpost',enqpost);
  var callurl= this.callurl + 'savelibtsad'
  

  // this.callurl=this.baseUrl+'Payenqrequest'
   return this.http.post( callurl, enqpost )
       .pipe(map((data: any) => 
       {
           console.log('retres',data);
           return  data ; 
       }));
} 


processlibtsar(rd: any): Observable<any> {

  var enqpost={clcd:this.clcd,aycd:this.aycd,said:rd.said,crby:this.usid,mdby:this.usid,rid:0};
      
      console.log('enqpost',enqpost);
      var callurl= this.callurl + 'processlibtsar'
  

  // this.callurl=this.baseUrl+'Payenqrequest'
   return this.http.post( callurl, enqpost )
       .pipe(map((data: any) => 
       {
           console.log('retres',data);
           return  data ; 
       }));
} 


savelibtsar(rd: any): Observable<any> {

  var enqpost={clcd:this.clcd,aycd:this.aycd,said:rd.said,crby:this.usid,mdby:this.usid,rid:rd.rid,alaccstatus:rd.alaccstatus};
      
      console.log('enqpost',enqpost);
      var callurl= this.callurl + 'savelibtsar'
  

  // this.callurl=this.baseUrl+'Payenqrequest'
   return this.http.post( callurl, enqpost )
       .pipe(map((data: any) => 
       {
           console.log('retres',data);
           return  data ; 
       }));
} 


getlibtsar(said,status): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  return this.http.get( this.callurl  + 'getlibtsar/'+this.clcd+'/'+this.aycd+'/'+said+'/'+status)
  .pipe(map((data: any) => {
          console.log('retres-getlibtsar', data);
          return data.libtsar;
          
      }));
}


getlibtbkref(frdt,todt): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  return this.http.get( this.callurl  + 'getlibtbkref/'+this.clcd+'/'+this.aycd+'/'+frdt+'/'+todt)
  .pipe(map((data: any) => {
          console.log('retres-libtbkref', data);
          return data.libtbkref;
          
      }));
}
bulkreturnbook(bookid: any): Observable<any> {
                        
  debugger
  bookid.usid=this.usid;
  // let clcd=localStorage.getItem('clcd');
  //         let aycd=localStorage.getItem('aycd');
  // var admdata={bookid:bookid,stuid:stuid,clcd:clcd,aycd:aycd}
 // bookid.crby=this.usid;
  return this.http.post(this.callurl + 'bulkreturnbook', bookid)
      .pipe(map((data: any) => {
          console.log('retres', 'response');
          return data
      }));
}

bulkrenewbook(bookid: any): Observable<any> {
                        
  debugger
  bookid.usid=this.usid;
  // let clcd=localStorage.getItem('clcd');
  //         let aycd=localStorage.getItem('aycd');
  // var admdata={bookid:bookid,stuid:stuid,clcd:clcd,aycd:aycd}
 // bookid.crby=this.usid;
  return this.http.post(this.callurl + 'bulkrenewbook', bookid)
      .pipe(map((data: any) => {
          console.log('retres', 'response');
          return data
      }));
}

bulkresbook(bookid: any): Observable<any> {
                        
  debugger
  // let clcd=localStorage.getItem('clcd');
  //         let aycd=localStorage.getItem('aycd');
  // var admdata={bookid:bookid,stuid:stuid,clcd:clcd,aycd:aycd}
  bookid.crby=this.usid;
  return this.http.post(this.callurl + 'bulkreservebook', bookid)
      .pipe(map((data: any) => {
          console.log('retres', 'response');
          return data
      }));
}

getlibtbkres(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  return this.http.get( this.callurl  + 'getlibtbkres/'+this.clcd+'/'+this.aycd)
  .pipe(map((data: any) => {
          console.log('retres-getlibtbkres', data);
          return data.libtbkres;
          
      }));
}

dellibtbkres(rid): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  
  return this.http.get( this.callurl  + 'dellibtbkres/'+this.clcd+'/'+this.aycd+'/'+rid)
  .pipe(map((data: any) => {
          console.log('retres-getlibtbkres', data);
          return data;
          
      }));
}
savelibtbkres(rd: any): Observable<any> {

  var enqpost={clcd:this.clcd,aycd:this.aycd,rmk:rd.rmk,mdby:this.usid,rid:rd.rid,resdt:rd.resdt,resstatus:rd.resstatus};
      
      console.log('enqpost',enqpost);
      var callurl= this.callurl + 'savelibtbkres'
  

  // this.callurl=this.baseUrl+'Payenqrequest'
   return this.http.post( callurl, enqpost )
       .pipe(map((data: any) => 
       {
           console.log('retres',data);
           return  data ; 
       }));
}

saveissueresbook(rd: any): Observable<any> {

  var enqpost={clcd:this.clcd,aycd:this.aycd,rmk:rd.rmk,crby:this.usid,rid:rd.rid,bookid:rd.bkid,memid:rd.memid,memtype:rd.memtype};
      
      console.log('enqpost',enqpost);
      var callurl= this.callurl + 'saveissueresbook'
  

  // this.callurl=this.baseUrl+'Payenqrequest'
   return this.http.post( callurl, enqpost )
       .pipe(map((data: any) => 
       {
           console.log('retres',data);
           return  data ; 
       }));
}

getlibebooks(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getlibmebooks', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.bookdetails;
          
      }));
}

getmemlibtindent(status): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  let roid=localStorage.getItem('role');
  return this.http.get(this.callurl + 'selmemlibtindent/'+this.clcd+'/'+this.aycd+'/'+this.usid+'/'+status +'/'+roid)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.libtindentlst;
          
      }));
}

getallibtindent(status): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.get(this.callurl + 'selallibtindent/'+this.clcd+'/'+this.aycd+'/'+status )
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.libtindentlst;
          
      }));
}

getqbblob(path,title): Observable<any> {
  debugger
  return this.http.get(path,{responseType: "blob"})
  .pipe(map(res => {
    return {
      filename: title+'.pdf',
      data: res
    };
  }))
}

getlibquestbank(fdta): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  console.log('fdta',fdta);
  let postdat={clcd:this.clcd,aycd:this.aycd,crsid:fdta.crsid,semid:fdta.semid};
  return this.http.post(this.callurl + 'getlibquestbank', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.qbdetails;
          
      }));
}

getlibebookdash(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getlibmebookdashcount', postdat)
  .pipe(map((data: any) => {
          console.log('dashcount', data);
          return data.dashcount;
          
      }));
}

savelibebook(boomodel,oprtype): Observable<any> {
  debugger
 var bk=boomodel;
  let postdat={clcd:this.clcd,aycd:this.aycd,author:bk.author,bkid:bk.ebkid,
    crby:this.usid,mdby:this.usid,deptid:bk.deptid,edition:bk.edition,languageid:bk.languageid,
    publisher:bk.publisher,pubplace:bk.pubplace,pubyr:bk.pubyr,subjectid:bk.subjectid,title:bk.title,titlesub:bk.titlesub,oprtype:oprtype,
rstatus:bk.rstatus,bktype:bk.bktype
  
  }
console.log('postdata',postdat);
  return this.http.post(this.callurl + 'savelibmebook', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

savelibtindent(boomodel,oprtype): Observable<any> {
  debugger
 var bk=boomodel;
  let postdat={clcd:this.clcd,aycd:this.aycd,author:bk.author,inid:bk.inid,
    usid:this.usid,edition:bk.edition, publisher:bk.publisher,note:bk.note,rmks:bk.rmks,title:bk.title,oprtype:oprtype,
indt:bk.indt,qty:bk.iqty,price:bk.price,year:bk.year
  
  }
console.log('postdata',postdat);
  return this.http.post(this.callurl + 'savelibtindent', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

authlibtindent(boomodel): Observable<any> {
  debugger
 var bk=boomodel;
  let postdat={clcd:this.clcd,aycd:this.aycd,inid:bk.inid,
    usid:this.usid,rmks:bk.rmks,instatus:bk.instatus,aqty:bk.aqty

  
  }
console.log('postdata',postdat);
  return this.http.post(this.callurl + 'authrizelibtindent', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

savelibquestbank(boomodel,oprtype): Observable<any> {
  debugger
 var bk=boomodel;
  let postdat={clcd:this.clcd,aycd:this.aycd,qbid:bk.qbid,subid:0,crsid:bk.crsid,semid:bk.semid,qbmonth:bk.qbmonth,qbyear:bk.qbyear,remarks:bk.remarks,crby:this.usid,oprtype:bk.oprtype,
    qbtitle:bk.qbtitle
  
  }
console.log('postdata',postdat);
  return this.http.post(this.callurl + 'savelibquestbank', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

serchebooks(sertext: any,booktype:any,bkcat:any): Observable<any> {
debugger
let clcd=localStorage.getItem('clcd');
let aycd=localStorage.getItem('aycd');
let postdat={sertxt:sertext,clcd:clcd,aycd:aycd,booktype:booktype,bkcat:bkcat}
return this.http.post(this.callurl+ 'serchbook', postdat)
    .pipe(map((data: any) => {
        console.log('retres', data);
        return data.bookdetails;
    }),delay(2000));
}



savestaffpublished(pstdata: any): Observable<any> {
                        
  debugger
  pstdata.usid=this.usid;
  pstdata.clcd=this.clcd;
  pstdata.aycd=this.aycd;
  // let clcd=localStorage.getItem('clcd');
  //         let aycd=localStorage.getItem('aycd');
  // var admdata={bookid:bookid,stuid:stuid,clcd:clcd,aycd:aycd}
  console.log('pstdata',pstdata);
  return this.http.post(this.callurl + 'savestaffpublished', pstdata)
      .pipe(map((data: any) => {
          console.log('retres', 'response');
          return data
      }));
}


getmemberrating(clid,crid): Observable<any> {
                        
  debugger

  return this.http.get(this.callurl + 'memberrating/'+this.clcd+'/'+this.aycd+'/'+clid+'/'+crid)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.arrmemrating;
      }));
}



getstaffpublished(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');libsubjectgroup
  //let postdat={clcd:this.clcd,aycd:this.aycd};
  return this.http.get(this.callurl + 'selstaffpublished/'+this.clcd+'/'+this.aycd)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.staffpublishedlst;
          
      }));
}

uploadebookFile(data: File,bkid): Observable<any> {
  /// this._url = 'http://localhost:4200/XXXXXXXXXX/uploadFile';

  const formData: FormData = new FormData();
  console.log("stuid",bkid)
  formData.append('Image', data, data.name);
    
    formData.append('bkid', bkid);
    formData.append('clcd', this.clcd);
    formData.append('aycd', this.aycd);
    console.log("formData",formData);
   return this.http.post(this._global.baseAPIUrl + 'uploadebook', formData)
   .pipe(map((data: any) => {
       console.log('retres', data);
       return data
   }));
}

uploadquestbank(data: File,qbid): Observable<any> {
  /// this._url = 'http://localhost:4200/XXXXXXXXXX/uploadFile';

  const formData: FormData = new FormData();
  console.log("stuid",qbid)
  formData.append('Image', data, data.name);
    
    formData.append('qbid', qbid);
    formData.append('clcd', this.clcd);
    formData.append('aycd', this.aycd);
    console.log("formData",formData);
   return this.http.post(this._global.baseAPIUrl + 'uploadquestbank', formData)
   .pipe(map((data: any) => {
       console.log('retres', data);
       return data
   }));
}

uploadstfpaper(data: File,qbid): Observable<any> {
  /// this._url = 'http://localhost:4200/XXXXXXXXXX/uploadFile';

  const formData: FormData = new FormData();
  console.log("stuid",qbid)
  formData.append('Image', data, data.name);
    
    formData.append('id', qbid);
    formData.append('usid', this.usid);
    formData.append('clcd', this.clcd);
    formData.append('aycd', this.aycd);
    console.log("formData",formData);
   return this.http.post(this._global.baseAPIUrl + 'uploadstaffpaper', formData)
   .pipe(map((data: any) => {
       console.log('retres', data);
       return data
   }));
}


uploadmemberphoto(data: File,bkid): Observable<any> {
  /// this._url = 'http://localhost:4200/XXXXXXXXXX/uploadFile';
debugger
  const formData: FormData = new FormData();
  console.log("stuid",bkid)
  formData.append('Image', data, data.name);
    
    formData.append('memid', bkid);
    formData.append('clcd', this.clcd);
    formData.append('aycd', this.aycd);
    console.log("formData",formData);
   return this.http.post(this._global.baseAPIUrl + 'uploadmemberphoto', formData)
   .pipe(map((data: any) => {
       console.log('retres', data);
       return data
   }));
}


getaccno_series(): Observable<any> {
  //let clcd=localStorage.getItem('clcd');
  
 // let postdat={clcd:this.clcd,aycd:this.aycd}
  //console.log('url',this.callurl + 'libdashboard/'+this.clcd+'/'+this.aycd+'/'+oprtype);
  return this.http.get(this.callurl + 'getaccno_series/'+this.clcd+'/'+this.aycd)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.accnos;
      }));
}

//var result = "NewFolder333".match(/[^\d]+|\d+/g);
}